var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35597 2.63884C5.28361 1.7112 6.81437 1.8065 7.61979 2.84204L9.86192 5.72478C10.2734 6.2538 10.4188 6.94261 10.2562 7.59278L9.57215 10.3291C9.49992 10.618 9.58457 10.9236 9.79513 11.1342L12.8659 14.2049C13.0764 14.4154 13.382 14.5001 13.6709 14.4279L16.4072 13.7438C17.0574 13.5812 17.7462 13.7266 18.2752 14.1381L21.158 16.3802C22.1935 17.1856 22.2888 18.7164 21.3612 19.644L20.0688 20.9364C19.1441 21.8611 17.7611 22.2671 16.4722 21.814C13.2719 20.6888 10.268 18.8468 7.71061 16.2894C5.15324 13.732 3.31119 10.7281 2.18605 7.52781C1.7329 6.2389 2.13891 4.8559 3.06356 3.93125L4.35597 2.63884Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.1fb52304fcaaa2ee17da9ced9926ff15.svg";
export { ForwardRef as ReactComponent };